import React from 'react'
import {
  Panel,
  ProgressBar,
  TooltipLabel,
  Title,
  SpacingVertical,
  Text,
  Spinner,
  SPACING_24,
  SPACING_8,
  TITLE_VARIANT_L,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'

const FlexColumn = styled.div`
  width: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
`

const StyledProgressNote = styled.p`
  color: var(--boulder);
  margin-top: 10px;
  width: 90%;
  align-self: center;
`

const StyledTooltipLabel = styled(TooltipLabel)`
  margin-top: -20px;
  align-self: flex-end;
`
const StyledTitle = styled(Title)`
  text-align: center;
`

const BoxProgress = ({
  queueStatus,
  variant,
  queuedPercentage,
  toBeQueued
}) => {
  const intl = useIntl()

  return (
    <Panel collapsible={false}>
      <FlexColumn>
        <SpacingVertical variant={SPACING_24} />
        <StyledTitle variant={TITLE_VARIANT_L}>
          {queueStatus === BEQUEUE_CONFIG_STATE_RUNNING && (
            <>
              <>
                {toBeQueued !== 0 ? intl.formatNumber(toBeQueued) : <Spinner />}
              </>{' '}
              <>
                {intl.formatMessage({ id: 'Load.QueueStatus.RecipientsNew' })}
              </>
            </>
          )}
          {queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED && (
            <>
              <>
                {toBeQueued !== 0 ? intl.formatNumber(toBeQueued) : <Spinner />}
              </>{' '}
              <>
                {intl.formatMessage({ id: 'Load.QueueStatus.RecipientsDone' })}
              </>
            </>
          )}
          {queueStatus === BEQUEUE_CONFIG_STATE_FAILED && (
            <>
              <>--</>{' '}
              <>
                {intl.formatMessage({ id: 'Load.QueueStatus.RecipientsNew' })}
              </>
            </>
          )}
        </StyledTitle>
        <StyledTooltipLabel variant={variant}>
          {queueStatus === BEQUEUE_CONFIG_STATE_FAILED && (
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({ id: 'Load.AsyncDetail.Error' })}
            </Text>
          )}
          {queueStatus === BEQUEUE_CONFIG_STATE_RUNNING && (
            <Text variant={TEXT_VARIANT_BOLD}>
              <>
                {intl.formatNumber(parseFloat(queuedPercentage), {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 0
                })}
                {'% '}
              </>
              <>
                {intl.formatMessage({
                  id: 'Load.EmailSendingWizard.QueueProgress'
                })}
              </>
            </Text>
          )}
          {queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED && (
            <Text variant={TEXT_VARIANT_BOLD}>
              <>
                {intl.formatNumber(parseFloat(queuedPercentage), {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 0
                })}
                {'% '}
              </>
              <>
                {intl.formatMessage({
                  id: 'Load.EmailSendingWizard.QueueProgress'
                })}
              </>
            </Text>
          )}
        </StyledTooltipLabel>
        <SpacingVertical variant={SPACING_8} />
        <ProgressBar width={queuedPercentage} variant={variant} />
        <StyledProgressNote>
          {intl.formatMessage(
            { id: 'Load.QueueStatus.RecipientsProgress' },
            { strong: chunks => <strong>{chunks}</strong> }
          )}
        </StyledProgressNote>
      </FlexColumn>
    </Panel>
  )
}

BoxProgress.propTypes = {
  queueStatus: PropTypes.number,
  variant: PropTypes.string,
  queuedPercentage: PropTypes.number,
  toBeQueued: PropTypes.number
}

export default BoxProgress
